import React from 'react';
import './style.scss'
import { Link, matchPath } from "react-router-dom";
import { Translation } from "react-i18next";
import i18n from "../../../i18n";
import { asset } from "../../../helpers/dom.helper";
import queryString from 'query-string';
import {isMobile} from 'react-device-detect';

class HeaderForJuristicAccounting extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {type: this.getParams()};
    
  }

  getIsMatch(pattern) {
    const path = this.props.match?.url
    return !!matchPath(path, { path: pattern })
  }

  getImageHeaderByType(type) {
    if (isMobile) {
      return type && type==='condominium' ? `url(${asset('/images/forJuristic/mobile/account-condo-mobile.webp')})`
      : type && type==='village' ? `url(${asset('/images/forJuristic/mobile/account-village-mobile.webp')})`
      : type && type==='online' ? `url(${asset('/images/forJuristic/mobile/account-online-mobile.webp')})`
      : `no`;
    } else {
      return type && type==='condominium' ? `url(${asset('/images/forJuristic/web/account-condo.webp')})`
            : type && type==='village' ? `url(${asset('/images/forJuristic/web/account-village.webp')})`
            : type && type==='online' ? `url(${asset('/images/forJuristic/web/account-online.webp')})`
            : `no`;
    }
  }

  getParams() {
    const params = queryString.parse(this.props.location.search)
    return this.getImageHeaderByType(params.type) 
  }

  render() {
    const newType = this.getParams()
    if (newType !== 'no') { this.setState({type: newType}) }
    return (
      <Translation ns={['translation', 'forJuristicAccounting']}>
        {(t) => (
          <div className="header-for-juristic-accounting" style={{
            '--foracc-bg-header': 
            this.state.type
          }}>
            <div className="container">
              <div className="row">
                <div className="col-12 text-center">
                  <div className="cover">
                    <h1>{t("forJuristicAccounting:Because Money Matters")}</h1>
                    {
                      !isMobile &&
                      <h2 dangerouslySetInnerHTML={{ __html: t("forJuristicAccounting:Effectively collect common area fees, examine accounts, monitor revenues, and reduce debts.") }} />
                    }
                    <Link to={(i18n.language !== "th" ? "/" + i18n.language : "") + "/register"}>
                      <button className="btn btn-light mt-4">
                        {t("forJuristicAccounting:Register Now")}
                      </button>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </Translation>
    );
  }
  
}

export default HeaderForJuristicAccounting;
